import { render, staticRenderFns } from "./WhatCanYouDo.vue?vue&type=template&id=a212f32a"
import script from "./WhatCanYouDo.vue?vue&type=script&lang=ts"
export * from "./WhatCanYouDo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports